document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('nav-overlay-trigger');
  var closeBtn = document.getElementById('nav-overlay-close');
  var overlay = document.getElementById('nav-overlay');

  if (!trigger || !overlay) return;

  function openNav() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nav-overlay-active');
  }

  function closeNav() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-overlay-active');
  }

  trigger.addEventListener('click', function () {
    var isOpen = overlay.classList.contains('is-open');
    if (isOpen) {
      closeNav();
    } else {
      openNav();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeNav);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });
});
